import { Tabs } from '@mantine/core';
import { InstanceResponseModel } from '../../../../../../apis/v1/instances/model';
import { InstanceListTable } from '../InstanceListTable/InstanceListTable';

interface InstanceListTabProps {
    instances?: InstanceResponseModel[];
    isLoading?: boolean;
}

export default function InstanceListTab({ instances, isLoading = false }: InstanceListTabProps) {
    return (
        <Tabs.Panel value={'instance'} className="w-full" style={{ padding: 'none !important' }}>
            <InstanceListTable instances={instances} isLoading={isLoading} />
        </Tabs.Panel>
    );
}
